import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../constants/site';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <header className="ftm-header">
      <div className="ftm-header-inner">
        <Link className="ftm-logo" to="/" onClick={() => setMenuOpen(false)}>
          <img src={`${process.env.PUBLIC_URL || ''}/logo.avif`} alt="" width={40} height={40} />
          <span>
            Family Tree <span className="ftm-logo-em">MAKER</span>
          </span>
        </Link>

        <nav id="ftm-nav" className={`ftm-nav ${menuOpen ? 'ftm-nav--open' : ''}`}>
          <a href="/#home" onClick={() => setMenuOpen(false)}>
            Home
          </a>
          <a href="/#about" onClick={() => setMenuOpen(false)}>
            About
          </a>
          <a href="/#contact" onClick={() => setMenuOpen(false)}>
            Contact
          </a>
        </nav>

        <a href={`tel:${SUPPORT_PHONE_TEL}`} className="ftm-header-phone">
          <Phone size={18} aria-hidden />
          {SUPPORT_PHONE_DISPLAY}
        </a>

        <button
          type="button"
          className="ftm-nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="ftm-nav"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span style={{ fontSize: '1.25rem' }}>{menuOpen ? '✕' : '☰'}</span>
        </button>
      </div>
    </header>
  );
}

export default Header;
